export default "__VITE_ASSET__CFeS8HIO__"